var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-5" },
    [
      _c("h1", [_vm._v("Los geht's!")]),
      _vm._v(" "),
      _c("Features"),
      _vm._v(" "),
      _c("div", { staticClass: "tag-sections mt-5" }, [
        _c(
          "section",
          { staticClass: "tag" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c("h2", [_vm._v("Deine E-Mail Adresse")]),
                    _vm._v(" "),
                    _c(
                      "FormGroup",
                      {
                        attrs: {
                          state: _vm.emailValid,
                          "invalid-feedback":
                            _vm.emailError && _vm.emailError.show
                              ? _vm.emailError.message
                              : undefined,
                          "feedback-beneath": ""
                        }
                      },
                      [
                        _c("b-input", {
                          attrs: { type: "email" },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-col", { attrs: { md: "6" } }, [
                  _c(
                    "div",
                    { staticClass: "mt-3 mt-md-0" },
                    [
                      _c("h2", [_vm._v("Dein Vorname")]),
                      _vm._v(" "),
                      _c(
                        "FormGroup",
                        [
                          _c("b-input", {
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.firstName,
                              callback: function($$v) {
                                _vm.firstName = $$v
                              },
                              expression: "firstName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "tag" },
          [
            _c("h2", [_vm._v("Setz dir ein sicheres Passwort")]),
            _vm._v(" "),
            _c("Password", {
              on: { input: _vm.emitChangeEvent },
              model: {
                value: _vm.password,
                callback: function($$v) {
                  _vm.password = $$v
                },
                expression: "password"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.password
          ? _c(
              "section",
              { staticClass: "tag" },
              [
                _c("h2", [_vm._v("Für wen suchst du?")]),
                _vm._v(" "),
                _c("b-form-radio-group", {
                  staticClass: "mt-0",
                  attrs: { options: _vm.customerTypeOptions, stacked: "" },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.customerType,
                    callback: function($$v) {
                      _vm.customerType = $$v
                    },
                    expression: "customerType"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.customerType
          ? _c(
              "section",
              { staticClass: "tag" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("h3", [_vm._v(_vm._s(_vm.companyTypeTitle))]),
                        _vm._v(" "),
                        _c("SingleSelect", {
                          attrs: {
                            "initial-value": _vm.companyType,
                            characteristics: _vm.meta.companyType,
                            "label-type": "job-profile"
                          },
                          on: { input: _vm.emitChangeEvent },
                          model: {
                            value: _vm.companyType,
                            callback: function($$v) {
                              _vm.companyType = $$v
                            },
                            expression: "companyType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-col", { attrs: { md: "6" } }, [
                      _c(
                        "div",
                        { staticClass: "mt-3 mt-md-0" },
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.companySizeTitle))]),
                          _vm._v(" "),
                          _c("SingleSelect", {
                            attrs: {
                              "initial-value": _vm.companySize,
                              characteristics: _vm.meta.companySize,
                              "label-type": "job-profile"
                            },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.companySize,
                              callback: function($$v) {
                                _vm.companySize = $$v
                              },
                              expression: "companySize"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "tag" },
          [
            _c("PrivacyCheckbox", {
              on: { input: _vm.emitChangeEvent },
              model: {
                value: _vm.privacy,
                callback: function($$v) {
                  _vm.privacy = $$v
                },
                expression: "privacy"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }